import PropTypes from "prop-types"

const PlanType = PropTypes.shape({
  name: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  interval: PropTypes.oneOf(["month", "year"]).isRequired,
  local_price_formatted: PropTypes.string.isRequired,
  local_price_formatted_monthly: PropTypes.string.isRequired,
  local_price_monthly: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
})

export default PlanType
